export default __webpack_public_path__ + "static/media/eye.495cee21.svg";